import { render } from "./svgHome.vue?vue&type=template&id=205b0b44"
import script from "./svgHome.vue?vue&type=script&lang=js"
export * from "./svgHome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\workspace\\repository\\sprfidspring\\src\\main\\vue-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__